import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import {TokenKeys} from "../../token.keys";
import {User} from "../../../data/models/auth.models";

@Injectable({
  providedIn: 'root',
})
export class DataService {

  private  tokenAccess:string="token.access_token";

  constructor(private router: Router, private location: Location, private http: HttpClient) { }

  setValue(key: string, value: unknown) {
    let object={};

    if(localStorage.getItem(this.tokenAccess) !== null) {
      object = JSON.parse(localStorage.getItem(this.tokenAccess) || '');
    }

    object[key] = value;

    if (key && value) {
      localStorage.setItem(this.tokenAccess, JSON.stringify(object));
    }
  }

  setUserToken(token: any) {
    if (token) {
      localStorage.setItem(TokenKeys.TokenKey, token);
    }
  }
  setRoleId(roleId: any) {
    localStorage.setItem('roleId', roleId);
  }

  getUserToken() {
    return localStorage.getItem(TokenKeys.TokenKey);
  }

  logoutUser() {
    localStorage.clear();
    this.router.navigateByUrl('/auth/login');
  }

  saveUserInfo(userInfo: any) {
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
  }

  getValue(key: string): any {

    let object={};

    if(localStorage.getItem(this.tokenAccess) !== null) {
      object = JSON.parse(localStorage.getItem(this.tokenAccess) || '');
    }

    return object[key];
  }

  deleteValue(key: any) {
    localStorage.removeItem(key);
  }

  response(res: any) {
    if (res.statusCode === 200) {
      return res;
    } else if (res.statusCode === 401) {
      this.router.navigateByUrl('/sign-in');
      throw new Error('Unauthorized access.');
    }
    throw new Error(`Unexpected response status: ${res.statusCode}`);
  }

  private appointmentDetails = new BehaviorSubject<object | null>(null);
  appointment = this.appointmentDetails.asObservable();

  setAppointmentDetails(appointment: any) {
    this.appointmentDetails.next(appointment);
  }

  getSavedUserDetails() {
    const userInfo = localStorage.getItem('userInfo');
    return userInfo ? JSON.parse(userInfo) : null;
  }

  getBack() {
    this.location.back();
  }

    setTenantSettings(tenantMenuSettings: any[]) {
      this.setValue(TokenKeys.tenatSettings,JSON.stringify(tenantMenuSettings));
    }

    getMenuSettings() {
      return JSON.parse(this.getValue(TokenKeys.tenatSettings))
    }

  setTenant(data) {
    this.setValue(TokenKeys.Tenant,JSON.stringify(data));
  }

  getTenant(){
    let value=this.getValue(TokenKeys.Tenant);

    if(value){
      return JSON.parse(value);
    }
    return null;
  }

  private static readonly CURRENCY_SYMBOLS: Record<string, string> = {
    ZAR: 'R', USD: '$', EUR: '€', GBP: '£', AUD: 'A$', CAD: 'C$',
    CHF: 'Fr', CNY: '¥', JPY: '¥', INR: '₹', AED: 'AED', NGN: '₦',
    KES: 'KSh', NZD: 'NZ$', SGD: 'S$',
  };

  get currencySymbol(): string {
    const code = this.getTenant()?.defaultCurrency;
    return (code && DataService.CURRENCY_SYMBOLS[code]) ?? 'R';
  }

    setGlobalTenant(tenant: any) {
        this.setValue(TokenKeys.GlobalTenant,JSON.stringify(tenant));
    }

  getGlobalTenant() {

    let value=this.getValue(TokenKeys.GlobalTenant);
    if(value){
      return JSON.parse(value);
    }
    return null;
  }

    setUser(user: any) {
      this.setValue(TokenKeys.User,JSON.stringify(user));
    }

    getUser(){
      let value=this.getValue(TokenKeys.User);

      if(value){
        return JSON.parse(value);
      }
      return null;
    }

  // Returns the tenant-specific support service base URL stored at login,
  // falling back to the environment default when not set.
  getSupportBaseUrl(): string {
    return this.getValue(TokenKeys.SupportServiceUrl) || environment.supportBaseUrl;
  }
}
